export default [{
    path: 'acknowledgements',
    component: () => import('source/pages/root/AcknowledgementsPageGroup.vue'),
    meta: {
        title: 'Acknowledgements - HQZen',
        canDisplayGlobalModals: true
    },
    children: [
        {
            path: '',
            name: 'acknowledgements',
            component: () => import('source/pages/acknowledgements/AcknowledgementsPage.vue'),
            meta: {
                title: 'Acknowledgements - HQZen',
                canDisplayGlobalModals: true,
                isInternal: true
            }
        }, {
            path: 'details',
            name: 'acknowledgement-details',
            component: () => import('source/pages/acknowledgements/AcknowledgementDetailsPage.vue'),
            meta: {
                title: 'Acknowledgements - HQZen',
                canDisplayGlobalModals: true,
                isInternal: true
            },
            children: [
                {
                    path: 'document',
                    name: 'acknowledgement-details-document',
                    component: () => import('source/pages/acknowledgements/AcknowledgementDocumentSubpage.vue'),
                    meta: {
                        title: 'Acknowledgements - HQZen',
                        canDisplayGlobalModals: true,
                        isInternal: true
                    }
                },
                {
                    path: 'signatory',
                    name: 'acknowledgement-details-signatory',
                    component: () => import('source/pages/acknowledgements/AcknowledgementSignatorySubpage.vue'),
                    meta: {
                        title: 'Acknowledgements - HQZen',
                        canDisplayGlobalModals: true,
                        isInternal: true
                    }
                }
            ]
        }
    ]
}];
